// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sideNav {
  margin: 15px 2px 0 0;
  /*    background-color: #E41B47; old colour*/
  background-color: #00C1D4;
  color: #fff;
  position: absolute;
  z-index: 100;
}

.sideBarContainer {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.toggleBtn {
  /*    background-color: #E41B47; old colour*/
  background-color: #00C1D4;
  color: white;
  border-top-right-radius: 50%;
  border-bottom-right-radius: 10px;
  cursor: pointer;
}

.inactiveSideBar {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACJ,4CAAA;EACI,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;AACJ;;AAEA;EACA,4CAAA;EACI,yBAAA;EACA,YAAA;EACA,4BAAA;EACA,gCAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,yBAAA;AACJ","sourcesContent":[".sideNav{\n    margin: 15px 2px 0 0;\n/*    background-color: #E41B47; old colour*/\n    background-color: #00C1D4;\n    color: #fff;\n    position: absolute;\n    z-index: 100;\n}\n\n.sideBarContainer{\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.toggleBtn{\n/*    background-color: #E41B47; old colour*/\n    background-color: #00C1D4;\n    color: white;\n    border-top-right-radius: 50%;\n    border-bottom-right-radius: 10px;\n    cursor: pointer;\n}\n\n.inactiveSideBar{\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
